import { useTenantContext } from '@trashlab/sitesapp/src/contexts/use-tenant-context';
import { getOrgModule } from '@trashlab/sitesapp/src/organizations/resolver';
import { GlobalCartModal } from '@trashlab/sitesapp/src/components/shop/global-cart-modal';

export const OrgTemplateSelector = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { website } = useTenantContext();
  const orgModule = getOrgModule(website?.organization?.id);
  const TemplateWrapper = orgModule.TemplateWrapper;

  return (
    <TemplateWrapper>
      <GlobalCartModal />
      {children}
    </TemplateWrapper>
  );
};
